import { z } from 'zod';
/**
 * Per `fan-wallet-and-points` capability — wallet, ledger, pricing
 * schemas. Two scopes (platform / group), one immutable ledger.
 */
export const WalletScopeSchema = z.enum(['platform', 'group']);
export const WalletRowSchema = z.object({
    /** Composite walletKey: `<fanId>` for platform, `<fanId>#<groupId>` for group. */
    walletKey: z.string().min(1),
    fanId: z.string().min(1),
    scope: WalletScopeSchema,
    groupId: z.string().uuid().optional(),
    balance: z.number().int().min(0),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const LedgerTxnTypeSchema = z.enum([
    'platform-topup',
    'platform-to-group-transfer',
    'chat-spend',
    'voice-spend',
    'customer-grant',
    'refund',
    'right-to-be-forgotten-payout',
    'group-to-platform-rollback',
]);
export const LedgerRowSchema = z.object({
    fanId: z.string().min(1),
    /** `<ISO ms>#<ULID>` */
    txnKey: z.string().min(1),
    txnId: z.string().min(1),
    type: LedgerTxnTypeSchema,
    delta: z.number().int(),
    balanceAfter: z.number().int().min(0),
    scope: WalletScopeSchema,
    groupId: z.string().uuid().optional(),
    refIds: z.object({
        trade: z.string().optional(),
        turnKey: z.string().optional(),
        voiceSessionId: z.string().optional(),
        grantedBy: z.string().optional(),
        relatedTxnId: z.string().optional(),
    }).default({}),
    note: z.string().max(200).optional(),
    ts: z.string().datetime(),
});
/** Per-character pricing override. Defaults: text=1, voice=3. */
export const PricingSchema = z.object({
    text: z.number().int().min(1).max(100).default(1),
    voice: z.number().int().min(1).max(300).default(3),
});
